import { Suspense, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DeleteModel from "../../Components/DeleteModel";
import Spinner from "../../Components/spinner";
import Breadcrumb from "../../Components/Breadcrumb";
import Pagination from "../../Components/Pagination";
import { formatDate } from "../../utils/constant";
import TableSearch from "../../Components/TableSearch";
import PerPageSelect from "../../Components/PerPageSelect";
import { useDebounce } from "../../hooks/useDebounce";
import {
  ActionButton,
  PlusButton,
  ToggleSwitch,
} from "../../Components/TableHelper";
import {
  deleteItem,
  fetchPaginationData,
  handleDragEnd,
  updateStatus,
} from "../../utils/apiUtils";
import BackButton from "../../Components/BackButton";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const PageSection = () => {
  const location = useLocation();
  const pageData = location.state;
  const { pageId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [nextSortOrder, setNextSortOrder] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [search, setSearch] = useState("");
  const navigator = useNavigate();
  const fetchDataPagination = async (
    page = 1,
    currentSearch = search,
    currentPerPage = perPage,
  ) => {
    const requestData = {
      perPage: currentPerPage,
      pageNo: page,
      search: currentSearch,
      pageBuilderId: pageId,
    };
    await fetchPaginationData(
      "pagesection/pagesection-pagination",
      requestData,
      setdata,
      setTotalCount,
      setCurrentPage,
      setLoading,
      setNextSortOrder,
    );
  };

  useEffect(() => {
    fetchDataPagination();
  }, []);

  const debouncedFetch = useDebounce((searchValue) => {
    fetchDataPagination(1, searchValue);
  }, 500);

  const handleSearchChange = (value) => {
    setSearch(value);
    debouncedFetch(value);
  };
  const handlePerPageChange = (value) => {
    setPerPage(value);
    fetchDataPagination(1, search, value);
  };

  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "pageSection/delete",
        deleteItemId?._id,
        fetchDataPagination,
      );
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };
  const handleOnDragEnd = (result) => {
    handleDragEnd({
      result,
      data: data,
      label: "Page Section",
      setData: setdata,
      model: "pageSection",
    });
  };
  const handleAdd = () => {
    navigator("/add-page-section/" + pageId, {
      state: { sortOrder: nextSortOrder },
    });
  };
  const handleEditClick = (item) => {
    navigator("/add-page-section/" + pageId, {
      state: item,
    });
  };
  const handlePageEditClick = (item) => {
    if (item.type === "CMS") {
      navigator("/add-cms", {
        state: item,
      });
    }
  };
  const handleStatusToggle = async (item) => {
    const updated = await updateStatus(
      item?._id,
      "pageSection",
      "Page Section",
    );
    if (!updated) return;

    setdata((prev) =>
      prev.map((curr) =>
        curr._id === updated._id
          ? { ...curr, isActive: updated.isActive }
          : curr,
      ),
    );
  };

  const handleBackClick = () => {
    navigator(`/page-builder`);
  };

  const Tableheader = [
    "No.",
    "Heading",
    "CMS Name",
    "Type",
    "Module",
    "Edit CMS",
    "Updated At",
    "Active",
    "Action",
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Page Section", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="custom-page-title">
            {pageData?.title || data?.[0]?.pageBuilderId?.title} &gt; &gt; Page
            Section
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div className="d-flex justify-content-between align-items-center bg-white p-2 mt-n2 flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <PerPageSelect value={perPage} onChange={handlePerPageChange} />
          </div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <BackButton handleClick={handleBackClick} />
            <TableSearch
              value={search}
              onChange={handleSearchChange}
              placeholder="Search By Title..."
            />
            <PlusButton handleAdd={handleAdd} module={"page builder"} />{" "}
          </div>
        </div>
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="Menus">
                    {(provided) => (
                      <div
                        className="table-responsive"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        <table
                          className=" custom-table table table-striped"
                          id="slidertable"
                        >
                          <thead>
                            <tr>
                              {Tableheader.map((item, index) => (
                                <th className="font-weight-bold " key={index}>
                                  {item}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  <Spinner />
                                </td>
                              </tr>
                            ) : data?.length > 0 ? (
                              data.map((item, index) => {
                                return (
                                  <Draggable
                                    key={item._id}
                                    draggableId={item._id.toString()}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <tr
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        ref={provided.innerRef}
                                      >
                                        <td>{item.sortOrder}</td>
                                        <td>
                                          {item?.heading
                                            ? item?.heading
                                            : "---"}
                                        </td>
                                        <td>{item?.cmsId?.title || "---"}</td>
                                        <td>{item?.type}</td>
                                        <td>{item?.moduleId?.name || "---"}</td>
                                        <td>
                                          {item?.type === "CMS" ? (
                                            <Button
                                              variant="primary"
                                              size="sm"
                                              onClick={() =>
                                                handlePageEditClick(item)
                                              }
                                            >
                                              Edit
                                            </Button>
                                          ) : (
                                            <p>---</p>
                                          )}
                                        </td>
                                        <td>{formatDate(item.updatedAt)}</td>
                                        <td>
                                          <ToggleSwitch
                                            data={item}
                                            name="isActive"
                                            checked={item.isActive}
                                            handleStatusToggle={
                                              handleStatusToggle
                                            }
                                            module={"Category"}
                                          />
                                        </td>
                                        <td>
                                          <ActionButton
                                            data={item}
                                            handleEditClick={handleEditClick}
                                            handleDelete={handleDelete}
                                            module={"page builder"}
                                            type={item?.type}
                                          />
                                        </td>
                                      </tr>
                                    )}
                                  </Draggable>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  <h5>No data found.</h5>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                {data?.length > 0 && (
                  <div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="page section"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default PageSection;
